import React from 'react'

import Breadcrumbs, {BreadcrumbsLink} from '../breadcrumbs/Breadcrumbs'

interface PageHeaderProps {
  currentPageTitle: string;
  breadcrumbsLinks?: BreadcrumbsLink[];
}

const PageHeader = ({currentPageTitle, breadcrumbsLinks}: PageHeaderProps) => {

  return (
    <div className="flex flex-col lg:-mt-10">
      {breadcrumbsLinks &&
        <div className="mb-2">
          <Breadcrumbs links={breadcrumbsLinks} />
        </div>
      }
      <div className="flex items-center">
        <h1 className="text-4.5xl font-semibold font-titillium text-kwota-neutral-800 capitalize">{currentPageTitle}</h1>
      </div>
    </div>
  )
}

export default PageHeader
